import React, { Component } from "react";
import { connect } from "react-redux";
import { func } from "prop-types";

import { applicationSendCode } from "../../logic/actions/api/application";
import { previous, next } from "../../logic/actions/navigation";
import { resendCode } from "../../logic/actions/resendVerificationCode";
import PageContent from "../PageContent";
import { logEvent, STEP_COMPLETED } from "../../logic/eventLogger";

export class PageVerificationCode extends Component {
  static propTypes = {
    applicationSendCode: func,
    previous: func,
  };

  constructor(props) {
    super(props);
    this.inputField = React.createRef();
    this.state = { pending: false };
    this.submit.bind(this);
    this.changeCode.bind(this);
  }

  componentDidMount() {
    this.inputField.current.focus();
  }

  changeCode = (e) => {
    this.setState({ code: e.target.value });
  };

  submit = (e) => {
    e.preventDefault();
    const code = this.state.code;
    if (code) {
      this.setState({ pending: true });
      this.props
        .applicationSendCode(code)
        .then(() => {
          this.props.next();
          logEvent(STEP_COMPLETED, { value: "sms_code" });
          logEvent(STEP_COMPLETED + "_sms_code");
        })
        .catch((err) => {
          if (err instanceof Error) {
            this.setState({
              error: err.toString(),
              pending: false,
            });
          } else {
            this.setState({
              error:
                "An error has occurred. Please try again and if the problem persists, contact your support.",
              pending: false,
            });
          }
        });
    } else {
      this.setState({ error: "Please enter valid code" });
    }
  };

  render() {
    return (
      <PageContent
        toggleLoading={this.state.pending}
        progressBar={true}
        progressPercentage={30}
      >
        <h1>Enter the verification code</h1>

        <form onSubmit={this.submit}>
          <p className="center">
            We've just sent a text message with a verification code to the
            submitted phone number.
          </p>
          <label>SMS code</label>
          <input
            ref={this.inputField}
            className="verification"
            type="number"
            onChange={this.changeCode}
          />
          <p className="error">{this.state.error}</p>
          <button className="btn blue" type="submit">
            Start
          </button>
          <p className="center">
            Didn’t receive the code?{" "}
            <button
              className="button-link"
              type="button"
              onClick={() => {
                this.props.resendCode();
                this.props.previous();
              }}
            >
              Resend it
            </button>
            .
          </p>
        </form>
      </PageContent>
    );
  }
}

export default connect((state) => state.livenessTest, {
  applicationSendCode,
  previous,
  resendCode,
  next,
})(PageVerificationCode);
